import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-question-field__counter" }


export default /*@__PURE__*/_defineComponent({
  __name: 'form-question-field',
  props: {
    modelValue: {},
    maxLength: { default: 512 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createBlock(_component_a_form_item, {
    class: "form-question-field stc-ant-field-skin",
    label: "Ваш вопрос",
    name: "question",
    required: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_textarea, {
        class: "form-question-field__textarea",
        value: __props.modelValue,
        maxlength: __props.maxLength,
        rows: "4",
        placeholder: "Опишите ваш вопрос подробно",
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
      }, null, 8, ["value", "maxlength"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.modelValue.length) + " / " + _toDisplayString(__props.maxLength), 1)
    ]),
    _: 1
  }))
}
}

})